export const sessionNames = {
  SESSION1: "Session 1",
  SESSION2: "Session 2",
  SESSION3: "Session 3",
};
